<template>
  <div>
    <div v-for="(item, index) in level_contents" :key="index" class="introduce_list">
      <div class="des_title">{{ item.title }}</div>
      <pre class="des_content">{{ item.content }}</pre>
      <div
        @click="routeSyllabuses"
        v-if="index === 0 && !isHideLink"
        class="syllabuses_text m-t-16"
      >
        {{ $t('Compare_syllabuses_a') }}>
      </div>
      <div v-if="index === 1 && !isHideLink" @click="routeLevel" class="m-t-16">
        <span class="syllabuses_text2">{{ $t('Not_sure') }}</span>
        <span class="syllabuses_text_weight">&ensp;&ensp;{{ $t('free_level_test') }} ></span>
      </div>
    </div>
    <!-- 弹窗 -->
    <DialogTest :visible="centerDialogVisible" @update:visible="dialogUpdate"></DialogTest>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import DialogTest from '@/components/DialogTest'
import analytics from '@/utils/AnalyticsCenter'
import { hideDescribeLink } from '@/utils/hskTool'
export default {
  components: {
    DialogTest,
  },
  props: {
    level_contents: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapState({
      levelActive: (state) => state.level.levelActive,
      isGrading: (state) => state.grade.isGrading,
    }),
    ...mapGetters('level', {
      levelActiveObj: 'levelActiveObj',
    }),
    computedLevelId() {
      return Number(this.levelActive || localStorage.getItem('LevelActive'))
    },
    isHideLink() {
      return hideDescribeLink.some((item) => item === this.$route.query.level)
    },
  },
  created() {
    // this.getIntroduce();
  },
  data() {
    return {
      centerDialogVisible: false, // 是否显示弹窗
    }
  },
  methods: {
    // 等级测试
    routeLevel() {
      let mixpanelParams = {
        exam_type: this.levelActiveObj.level_name,
      }
      analytics.logEvent('hskweb_abtlevelleveltest_click', mixpanelParams)
      console.log('====', this.isGrading)
      if (this.isGrading) {
        this.$router.push({
          name: 'levelReport',
        })
      } else {
        this.centerDialogVisible = true
      }
    },
    routeSyllabuses() {
      let mixpanelParams = {
        exam_type: this.levelActiveObj.level_name,
      }
      analytics.logEvent('hskweb_abtlevelcompare_click', mixpanelParams)
      this.$router.push('/hsk/syllabuses')
    },
    // 弹窗显示状态发生变化
    dialogUpdate(val) {
      this.centerDialogVisible = val
    },
  },
}
</script>
<style scoped>
.introduce_list {
  margin-bottom: 30px;
  line-height: normal;
  padding-bottom: 30px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
strong {
  font-weight: bold;
  word-break: break-word;
  font-size: 16px;
}
pre {
  line-height: 30px;
  white-space: pre-wrap;
  word-break: break-word;
  background-color: #ffffff !important;
}
.syllabuses_text {
  color: #474b64;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  cursor: pointer;
}
.syllabuses_text_weight {
  color: #474b64;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  cursor: pointer;
  line-height: normal;
}
.des_title {
  color: #2c2f46;
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-bottom: 16px;
}
.des_content {
  color: #696974;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
}
.m-t-16 {
  margin-top: 16px;
}
.syllabuses_text2 {
  color: #474b64;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  cursor: pointer;
}
</style>
